var map = {
	"./ACGIH-Heavy": 397,
	"./ACGIH-Heavy.json": 397,
	"./ACGIH-Light": 398,
	"./ACGIH-Light.json": 398,
	"./ACGIH-Moderate": 399,
	"./ACGIH-Moderate.json": 399,
	"./ACSM-Acclimatized": 400,
	"./ACSM-Acclimatized.json": 400,
	"./ACSM-NonAcclimatized": 401,
	"./ACSM-NonAcclimatized.json": 401,
	"./GaStateHighSchool": 402,
	"./GaStateHighSchool.json": 402,
	"./KyStateHighSchool": 403,
	"./KyStateHighSchool.json": 403,
	"./NATA": 404,
	"./NATA.json": 404,
	"./NcStateHighSchool": 405,
	"./NcStateHighSchool.json": 405,
	"./NjStateHighSchool": 406,
	"./NjStateHighSchool.json": 406,
	"./TBMed507-Easy": 407,
	"./TBMed507-Easy.json": 407,
	"./TBMed507-Hard": 408,
	"./TBMed507-Hard.json": 408,
	"./TBMed507-Moderate": 409,
	"./TBMed507-Moderate.json": 409,
	"./UsaSoccer-Cat1": 410,
	"./UsaSoccer-Cat1.json": 410,
	"./UsaSoccer-Cat2": 411,
	"./UsaSoccer-Cat2.json": 411,
	"./UsaSoccer-Cat3": 412,
	"./UsaSoccer-Cat3.json": 412,
	"./VtStateHighSchool": 413,
	"./VtStateHighSchool.json": 413,
	"./_HeatStressGuidelinesIndex": 318,
	"./_HeatStressGuidelinesIndex.json": 318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 603;